const ArrowDownIcon = ({ fill = '#363853' }: { fill?: string }) => {
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg" fill="none">
      <path d="M11 1.5L6 6.5L1 1.5" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ArrowDownIcon;
